import React, { useEffect, useState } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import HomeHero from './HomeHero';
import HomeFeatures from './HomeFeatures';
import HomeEvents from './HomeEvents';
import HomeCTA from './HomeCTA';
import LogoPatternBackground from '../../components/common/LogoPatternBackground';
import MusicNotesBackground from '../../components/common/MusicNotesBackground';

const HomePage = () => {
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Sayfa yükleme animasyonu
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1200);
    
    // Smooth scroll 
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Sayfa yüklendiğinde en üste kaydır
    window.scrollTo(0, 0);
    
    return () => {
      clearTimeout(timer);
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);
  
  // Scroll-to-top fonksiyonu
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen flex flex-col overflow-hidden relative">
      {/* Sayfa Yükleniyor Animasyonu */}
      <div className={`fixed inset-0 bg-indigo-950 z-50 flex flex-col items-center justify-center transition-opacity duration-500 ${loading ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <div className="flex items-center space-x-2 mb-6">
          {['♪', 'İ', 'Y', 'T', 'E', '♫', 'M', 'ü', 'z', 'i', 'k', '♬'].map((char, index) => (
            <span 
              key={index} 
              className="text-3xl font-bold text-white"
              style={{
                animation: `bounce 0.5s ${index * 0.05}s infinite alternate`,
                display: 'inline-block'
              }}
            >
              {char}
            </span>
          ))}
        </div>
        <div className="w-64 h-2 bg-indigo-300/30 rounded-full overflow-hidden">
          <div className="h-full bg-white rounded-full animate-loading-bar"></div>
        </div>
      </div>
      
      {/* Koyu arka plan */}
      <div className="fixed inset-0 bg-indigo-950 z-0"></div>
      
      {/* Logo Arka planı */}
<div className="fixed inset-0 z-0">
  <LogoPatternBackground opacity={0.025} size={100} animate={true} color="white" />
</div>

{/* Müzik Notaları Arka planı - biraz daha önde */}
<div className="fixed inset-0 z-1">
  <MusicNotesBackground opacity={0.55} animate={true} noteCount={150} />
</div>


      
      {/* Navbar */}
      <Navbar />
      
      {/* İçerik */}
      <div className="flex-grow">
        <HomeHero />
        <HomeFeatures />
        <HomeEvents />
        <HomeCTA />
      </div>
      
      <Footer />
      
      {/* Scroll-to-top button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 bg-indigo-500 text-white w-12 h-12 rounded-full shadow-lg flex items-center justify-center z-40 hover:bg-indigo-600 transition-all duration-300 transform hover:scale-110"
        aria-label="Sayfa başına dön"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>
      
      {/* Animasyon stilleri */}
      <style>
        {`
        @keyframes bounce {
          from {
            transform: translateY(0);
          }
          to {
            transform: translateY(-10px);
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        .animate-loading-bar {
          width: 100%;
          animation: loading 1.2s linear infinite;
        }
        
        @keyframes loading {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}
      </style>
    </div>
  );
};

export default HomePage;